module.exports = __webpack_public_path__ + "static/mood-trackerMockup-fb0ffbc522b7170013bbb192153806a2.png";